import { getPriceGraphAvailability } from 'client/site-modules/shared/utils/inventory/get-price-graph-availability';
import { getPriceCheckerPromoAvailability } from 'client/site-modules/shared/utils/inventory/get-price-checker-promo-availability';

export function getPromoView({ vinData, location }) {
  const hasPriceGraph = getPriceGraphAvailability(vinData, location);
  const showPriceCheckerPromo = getPriceCheckerPromoAvailability(vinData);

  if (hasPriceGraph) {
    return 'dropGraph';
  } else if (showPriceCheckerPromo) {
    return 'ratingGraph';
  }

  return false;
}
